import { FC, ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsAuth } from '@src/store/ducks/app/selectors'

type PrivateRouteProps = {
  Component: ReactElement
}

export const PrivateRoute: FC<PrivateRouteProps> = ({ Component }) => {
  const isAuth = useSelector(selectIsAuth)

  if (!isAuth) return <Navigate to="/lk/login" />

  return Component
}
